import { Chart } from 'react-chartjs-2';
import { useGetByIdAndTimeSummarizedQuery } from '../../../services/historicalData';
import { useEffect, useMemo, useState } from 'react';
import { useGetMediumColor } from '../../../hooks/useGetMediumColor';
import { Block } from 'baseui/block';
import { addDays, addMonths, format } from 'date-fns';
import { FormattedMessage, useIntl } from 'react-intl';
import { datasetFromData, ICounterAndData } from './utils';
import { ICounter } from '../../Devices/Counter';
import { useStyletron } from 'baseui';
import { Banner } from 'baseui/banner';
import { SingleMonthlyEnergy } from './';
import { defaultOptions } from './defaultOptions';
import { useGetLanguage } from '../../../hooks/useGetLanguage';
import React from 'react';
import { ValueDisplay, ValueDisplayWithLabel } from '../../components/ValueDisplay';
import { AiOutlineArrowRight } from 'react-icons/ai';
import Xarrow from 'react-xarrows';
import { MdBattery60, MdBatteryCharging50, MdOutlineLocationCity, MdSolarPower } from 'react-icons/md';
import { ImPower } from 'react-icons/im';
import { themedUseStyletron } from '../../../theme/customTheme';
import { Icon } from '../../Devices/ElectricHeatingElement/Icon';
import { Card } from 'baseui/card';

export interface PowerOverviewProps {
    powerGridIn: number,
    powerGridOut: number,
    powerStorageIn: number,
    powerStorageOut: number,
    powerPV: number,
    dimension: string,
    hasStorage: boolean,
}

// animations don't work in react.strickmode - see https://github.com/Eliav2/react-xarrows/issues/151

function PowerOverview({ powerGridIn, powerGridOut, powerStorageIn, powerStorageOut, powerPV, dimension, hasStorage }: PowerOverviewProps) {
    const intl = useIntl();
    const { locale } = useGetLanguage();
    const [, theme] = themedUseStyletron();



    const powerUsed = powerGridIn + powerGridOut + powerStorageIn + powerStorageOut + powerPV;

    return (
        <>
            <Block display='flex' flexDirection='row' gridRowGap='52px' alignItems='center' justifyContent='space-between'>
                <Block display='flex' flexDirection='column' gridGap='52px' alignItems='center' justifyContent='space-between' >

                    <div id={'Grid'}>
                        {<EnergyItem MyIcon={ImPower} value={(powerGridIn > 0 || powerGridOut === 0)?powerGridIn:powerGridOut} dimension={dimension}></EnergyItem>}
                    </div>
                </Block>
                <Block display='flex' flexDirection='column' gridGap='52px' alignItems='center' justifyContent='space-between' >
                    <div id={'PV'}>
                        {<EnergyItem MyIcon={MdSolarPower} value={powerPV} dimension={dimension}></EnergyItem>}
                    </div>
                    <div id={'Used'}>
                        <EnergyItem MyIcon={MdOutlineLocationCity} value={powerUsed} dimension={dimension}></EnergyItem>
                    </div>
                </Block>
                <Block display='flex' flexDirection='column' gridGap='52px' alignItems='center' justifyContent='space-between' >
                    <div id={'Storage'}>
                        {hasStorage && <EnergyItem MyIcon={MdBatteryCharging50} value={(powerStorageOut < 0 || (hasStorage && powerStorageIn <= 0))?powerStorageOut:powerStorageIn} dimension={dimension}></EnergyItem>}
                    </div>
                </Block>

            </Block >
            {(powerGridIn > 0 || powerGridOut === 0) && <Xarrow dashness={{ strokeLen: 5, nonStrokeLen: 5, animation: 2 }} start="Grid" end="Used"  color={powerGridIn === 0 ? theme.appColors.aggregate.off : theme.appColors.aggregate.error} strokeWidth={2} endAnchor="left" startAnchor="right"></Xarrow>}
            {powerGridOut < 0 && <Xarrow dashness={{ strokeLen: 5, nonStrokeLen: 5, animation: 2 }} start="Used" end="Grid"  color={theme.appColors.aggregate.on} strokeWidth={2} endAnchor="right" startAnchor="left"></Xarrow>}
            {<Xarrow dashness={{ strokeLen: 5, nonStrokeLen: 5, animation: 2 }} start="PV" end="Used" color={powerPV === 0 ? theme.appColors.aggregate.off : theme.appColors.aggregate.on} strokeWidth={2} endAnchor="top" startAnchor="bottom"></Xarrow>}

            {hasStorage && powerStorageIn > 0 && <Xarrow dashness={{ strokeLen: 5, nonStrokeLen: 5, animation: 2 }} start="Storage" end="Used"  color={theme.appColors.aggregate.off} strokeWidth={2} endAnchor="right" startAnchor="left"></Xarrow>}
            {(hasStorage && powerStorageOut < 0 || (hasStorage && powerStorageIn <= 0)) && <Xarrow dashness={{ strokeLen: 5, nonStrokeLen: 5, animation: 2 }} start="Used" end="Storage" color={theme.appColors.aggregate.on} strokeWidth={2} endAnchor="left" startAnchor="right"></Xarrow>}
        </>
    );
}


export default React.memo(PowerOverview)


function EnergyItem({ MyIcon, value, dimension }: any) {
    const [, theme] = themedUseStyletron();
    return (
        <Card>
        <Block display='flex' flexDirection='column' gridGap='25px' alignItems='center' justifyContent='space-between' >
            <MyIcon color={theme.colors.contentSecondary} size='40px'></MyIcon>
            <ValueDisplay value={value} small dimension={dimension}></ValueDisplay>
        </Block>
        </Card>
    )

}